import Experience from "./Experience";

/* 
  This class manages the modal functionality, including opening and closing modals,
  displaying different content based on user interaction, and handling specific modal behaviors.
*/
class Modal {
  constructor() {
    this.experience = new Experience();
    this.modal = document.querySelector(".modal");
    this.closeButtons = document.querySelectorAll("[data-close]");
    this.openButtons = document.querySelectorAll("[data-open]");
    this.modalContent = this.modal.querySelectorAll("[data-modal]");

    this.setupEventListeners();

    this.hasPlayedAudio = false;
  }

  show(contentToShow = null, event = null) {
    let modalContent;

    // If the method is triggered by an event, use event dataset
    if (event) {
      modalContent = event.currentTarget.dataset.open;
    } else {
      // If called programmatically, use the argument passed in
      modalContent = contentToShow;
    }

    // Now we can safely toggle the content visibility
    this.modalContent.forEach((content) => {
      if (content.dataset.modal === modalContent) {
        content.classList.add("active");
      } else {
        content.classList.remove("active");
      }

      if (modalContent === "about") {
        this.modal.classList.add("modal--about"); // Add a specific class for the about modal for styling
      } else {
        this.modal.classList.remove("modal--about");
      }
    });

    this.modal.showModal(); // this method comes from the native HTML dialog element
    document.body.classList.add("no-scroll");
  }

  hide() {
    this.modalContent.forEach((content) => {
      content.classList.remove("active");
    });

    if (this.modal.classList.contains("modal--about")) {
      this.modal.classList.remove("modal--about");
    } else {
      // if the modal being closed is the legal modal, play the audio
      if (!this.hasPlayedAudio) {
        this.hasPlayedAudio = true;
        this.experience.toggleAudio();
      }
    }

    this.modal.close();
    document.body.classList.remove("no-scroll");
  }

  setupEventListeners() {
    this.closeButtons.forEach((button) => {
      button.addEventListener("click", this.hide.bind(this));
    });

    this.openButtons.forEach((button) => {
      button.addEventListener("click", (event) => this.show(null, event));
    });
  }

  setFallback() {
    this.show("about");

    // hide the close button
    this.closeButtons.forEach((button) => {
      button.style.display = "none";
    });

    // remove main from the dom
    document.querySelector("main").remove();
  }
}

export default Modal;
